import RequireSuperAdminMiddleware from 'middlewares/RequireSuperAdminMiddleware'

export default [
    {
        path: '/admin/claim-your-profile',
        name: 'admin.claim-your-profile',
        view: 'admin/ClaimYourProfile',
        default: { query: { status: 'all' } },
        middlewares: [RequireSuperAdminMiddleware],
    },
    {
        path: '/admin/invites-member/invite-by-email',
        name: 'admin.invite-by-email',
        view: 'admin/InvitesMemberByEmail',
        middlewares: [RequireSuperAdminMiddleware],
    },
    {
        path: '/admin/invites-member/invite-by-phone',
        name: 'admin.invite-by-phone',
        view: 'admin/InvitesMemberByPhone',
        middlewares: [RequireSuperAdminMiddleware],
    },
    {
        path: '/admin/manage-license-status',
        name: 'admin.manage-license-status',
        view: 'admin/ManageLicenseStatus',
        middlewares: [RequireSuperAdminMiddleware],
    },
    {
        path: '/admin/outreach-tasks',
        name: 'admin.outreach-tasks',
        view: 'admin/OutreachTasks',
        middlewares: [RequireSuperAdminMiddleware],
    },
]
